import { getMyStaffShell } from '@/actions/permissions';
import type { StaffShell } from '@/lib/staffShell';
import { noteAction } from '@/lib/perf/shellChain';

let inflight: Promise<StaffShell> | null = null;

/**
 * One in-flight shell request per page. React Strict Mode remounts the
 * provider effect; joining the same promise keeps that from doubling the
 * Server Action.
 */
export function loadStaffShell(opts?: { retry?: boolean }): Promise<StaffShell> {
  if (inflight) return inflight;
  noteAction('getMyStaffShell', { retry: opts?.retry });
  inflight = getMyStaffShell().finally(() => {
    inflight = null;
  });
  return inflight;
}
